// src/components/Transactions/SuggestionItem.js
import React from "react";
import { cleanTransactionName } from "../../utils/cleanTransactionName";

const SuggestionItem = ({ 
  transaction, 
  suggestion, 
  confidence, 
  matchType,
  onAccept, 
  onIgnore,
  cleanedName 
}) => {
  // Format date for display
  const formattedDate = new Date(transaction.date).toLocaleDateString('pt-BR');
  
  // Format amount for display
  const formattedAmount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(transaction.amount);
  
  // Determine confidence color (ainda usado para borda do badge)
  const getConfidenceColor = () => {
    if (confidence >= 0.9) return '#4caf50'; // Green
    if (confidence >= 0.7) return '#2196f3'; // Blue
    if (confidence >= 0.5) return '#ff9800'; // Orange
    return '#757575'; // Gray
  };
  
  // Use cleaned name if provided, otherwise clean the description
  const transactionName = cleanedName || cleanTransactionName(transaction.description, transaction.bankInfo?.org || '');
  
  return (
    <div className="suggestion-content">
      <div className="suggestion-transaction">
        <div className="transaction-header">
          <span className="transaction-date">{formattedDate}</span>
          <span className={`transaction-amount ${transaction.amount >= 0 ? 'amount-positive' : 'amount-negative'}`}>
            {formattedAmount}
          </span>
        </div>
        
        <p className="transaction-description" title={transactionName}>
          {transactionName}
        </p>
      </div>
      
      <div className="suggestion-arrow">→</div>
      
      <div className="suggestion-category">
        <div className="category-badge suggested" style={{ borderColor: getConfidenceColor() }}>
          {suggestion.category}
        </div>
        
        <div className="suggestion-details">
          <p className="category-path">{suggestion.categoryPath}</p>
          
          {matchType === 'similar' && (
            <span className="match-type">
              Correspondência similar
            </span>
          )}
        </div>
      </div>
      
      <div className="suggestion-actions">
        <button 
          className="accept-suggestion"
          onClick={() => onAccept()}
        >
          ✓ Aceitar
        </button>
        
        <button 
          className="ignore-suggestion"
          onClick={() => onIgnore()}
        >
          × Ignorar
        </button>
      </div>
    </div>
  );
};

export default SuggestionItem;